"use strict";
/**
 * Savecard Factory
 * formats the raw data into a usable format
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
/**
 * Returns formatted saveCard info
 * @param {SaveCardType} saveCard
 * @returns {SaveCardFactoryType}
 */
function saveCardFactory(saveCard) {
    return {
        id: (0, get_1.default)(saveCard, 'id', ''),
        last4Digit: (0, get_1.default)(saveCard, 'last4Digit', ''),
        expired: (0, get_1.default)(saveCard, 'expired', false),
        expiryMonth: (0, get_1.default)(saveCard, 'expiryMonth', ''),
        expiryYear: (0, get_1.default)(saveCard, 'expiryYear', ''),
        scheme: (0, get_1.default)(saveCard, 'scheme', ''),
    };
}
exports.default = saveCardFactory;
